import { useCallback, useContext } from 'react';
import { AnalysisInProgressContext } from '../ContextWrapper';
import useInitializeAnalysis from './useInitializeAnalysis';
import moment from 'moment';


export default function useStartAnalysis() {
    const {
        setIsAnalysisInProgress,
        flushAnalysisData,
        setLastAnalysisGuid,
        setLastAnalysisUrl,
        setLastAnalysisSections,
        setLastAnalysisCreatedAt,
        setLastAnalysisCompetitors,
    } = useContext(AnalysisInProgressContext);

    const { initializeAnalysis } = useInitializeAnalysis();

    const startAnalysis = useCallback(
        async (url: string, competitors?: string[], sections?: string[]) => {
            flushAnalysisData();
            setIsAnalysisInProgress(true);

            const [mainUrlResponse, ...competitorsResponse] = await initializeAnalysis(url, competitors, sections);

            if (mainUrlResponse) {
                setLastAnalysisCreatedAt(moment.utc().format('YYYY-MM-DDTHH:mm:ss'));
                setLastAnalysisUrl(mainUrlResponse.url);
                setLastAnalysisGuid(mainUrlResponse.guid);
                setLastAnalysisSections(mainUrlResponse.sections);

                const competitors = competitorsResponse
                    .filter((response) => response !== undefined)
                    .map((response) => ({ reportGuid: response!.guid, websiteUrl: response!.url }));

                setLastAnalysisCompetitors(competitors);
            } else {
                setIsAnalysisInProgress(false);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return { startAnalysis };
}